export default {"src":"/_next/static/media/file.f17d067e.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};